// export const BASE_API = "http://localhost:5000/api/v1";

export const BASE_API = process.env.REACT_APP_BASE_API;